import { useParams } from 'react-router-dom';
import { BooleanField } from '../../../components/admin/boolean-field';
import { DataTable } from '../../../components/admin/data-table';
import { DateField } from '../../../components/admin/date-field';
import { MoonstarList } from '../../Moonstar/MoonstarList';

export const NudgeFeedbackList = () => {
  const { nudgeId } = useParams();

  return (
    <MoonstarList
      actions={false}
      filter={{ nudgeId }}
      sort={{ field: 'createdOn', order: 'DESC' }}
    >
      <DataTable bulkActionButtons={false}>
        <DataTable.NumberCol source="rating" />
        <DataTable.Col source="isInteresting">
          <BooleanField source="isInteresting" />
        </DataTable.Col>
        <DataTable.Col source="createdOn" className="w-full">
          <DateField source="createdOn" />
        </DataTable.Col>
      </DataTable>
    </MoonstarList>
  );
};
